export interface Notification {
  id: string;
  title: string;
  message: string;
  type: NotificationType;
  status: NotificationStatus;
  userId: string;
  entityType?: EntityType;
  entityId?: string;
  metadata?: Record<string, any>;
  createdAt: string; // ✅ Cambiar a string ISO para Redux serialización
  readAt?: string;   // ✅ Cambiar a string ISO para Redux serialización
  expiresAt?: string; // ✅ Cambiar a string ISO para Redux serialización
}

export enum NotificationType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  PROPERTY_ADDED = 'property_added',
  PROPERTY_UPDATED = 'property_updated',
  QUOTE_CREATED = 'quote_created',
  QUOTE_APPROVED = 'quote_approved',
  QUOTE_REJECTED = 'quote_rejected',
  LEAD_QUALIFIED = 'lead_qualified',
  APPOINTMENT_SCHEDULED = 'appointment_scheduled',
  APPOINTMENT_CANCELLED = 'appointment_cancelled',
  SALE_COMPLETED = 'sale_completed',
  COMMISSION_EARNED = 'commission_earned',
  SYSTEM_MAINTENANCE = 'system_maintenance',
  TASK_CREATED = 'task_created',
  TASK_ASSIGNED = 'task_assigned',
  TASK_COMPLETED = 'task_completed',
  TASK_OVERDUE = 'task_overdue',
}

export enum NotificationStatus {
  UNREAD = 'unread',
  READ = 'read',
  ARCHIVED = 'archived',
}

export enum EntityType {
  PROPERTY = 'property',
  QUOTE = 'quote',
  LEAD = 'lead',
  CLIENT = 'client',
  APPOINTMENT = 'appointment',
  SALE = 'sale',
  COMMISSION = 'commission',
  USER = 'user',
  TASK = 'task',
}

export interface NotificationFilters {
  status?: NotificationStatus;
  type?: NotificationType;
  entityType?: EntityType;
  userId?: string;
  tenantId?: string;
  limit?: number;
  offset?: number;
}

export interface NotificationStats {
  total: number;
  unread: number;
  read: number;
  archived: number;
  byType: Record<NotificationType, number>;
  byStatus: Record<NotificationStatus, number>;
}

export interface NotificationResponse {
  success?: boolean;
  message?: string;
  data?: {
    notifications: Notification[];
    total: number;
  };
  notifications?: Notification[];
  total?: number;
  hasMore?: boolean;
}

export interface MarkAsReadRequest {
  notificationIds: string[];
}

export interface MarkAllAsReadRequest {
  userId: string;
}

export interface DeleteNotificationRequest {
  notificationId: string;
}

// WebSocket Events
export interface NotificationWebSocketEvent {
  type: 'notification_created' | 'notification_updated' | 'notification_deleted';
  data: Notification;
  timestamp: string; // ✅ Cambiar a string ISO para Redux serialización
}

export interface NotificationConnectionEvent {
  type: 'connected' | 'disconnected' | 'error';
  message?: string;
  timestamp: Date;
}

/**
 * GH#2673 — cuerpo de «enviar una notificación a OTRA persona» (el aviso del embudo de clientes). Venía del segundo cliente
 * (`shared/services/notification.service.ts`, ya borrado). La ruta `POST /notifications/broadcast/user` NO existe en el API.
 */
export interface SendToUserPayload {
  userId: string;
  title: string;
  message: string;
  type?: 'info' | 'success' | 'warning' | 'error' | 'system';
  category?: 'client' | 'property' | 'agent' | 'financial' | 'marketing' | 'system' | 'crm';
  metadata?: Record<string, any>;
  actionUrl?: string;
  actionLabel?: string;
  expiresAt?: string;
}
